import axios from 'axios';
import updateSelectFromArray from "../../new-car-pages/modules/details/finance/finance-types/update-select-from-array";

const newModelCache = {};

const updateNewModels = function(brand) {
    return new Promise((resolve, reject) => {
        if (brand == '') {
            resolve([]);
        }
        if (typeof newModelCache[brand] == 'undefined') {
            axios.post('/ajax/new/homepage-options', {
                brand: brand
            })
            .then(response => {
                newModelCache[brand] = response.data;
                resolve(response.data);
            })
            .catch(error => {
                console.error('Error getting new models for brand', brand, error);
                reject();
            });
            return;
        }

        resolve(newModelCache[brand]);
    })
};

const handleNewMakeChange = function(element, newModelSelect, homepageSearchBoxSubmitButton, newOrUsedSelect) {
    if (newOrUsedSelect.value != 'new') {
        return;
    }
    if (element.value == '') {
        homepageSearchBoxSubmitButton.setAttribute('disabled', true);
    } else {
        homepageSearchBoxSubmitButton.removeAttribute('disabled');
    }
    updateNewModels(element.value)
    .then(models => {
        updateSelectFromArray(
            [
                {short_name: '', route: ''},
                ...models
            ],
            newModelSelect,
            value => {
                if (value.short_name != '') {
                    return value.short_name;
                }
                return 'Select model';
            },
            value => {
                if (value.id) {
                    return value.id;
                }
                return '';
            },
            (value, option) => {
                option.dataset.url = value.route;
            }
        );
    });
};

/**
 * Setup events on the new part of the search form to populat models and handle disabling the search button
 *
 * @param {HTMLElement} form
 * @returns {Function} export of the callback to populate the models and disable button
 */
const setupNewForm = function(form) {
    if (!form) {
        console.error("Couldn't find homepage new search form");
        return;
    }

    const newModelSelect = form.querySelector('select[name="new_model"]');
    const newOrUsedSelect = form.querySelector('[name="new_or_used"]');
    const homepageSearchBoxSubmitButton = form.querySelector('.btn--primary');

    const newMake = form.querySelector('[name="new_make"]');
    // If the input is a hidden one, then the make never changes and we don't need to load in dynamic results
    if (newMake.tagName.toLowerCase() == 'input') {
        return function() {};
    }


    newMake.addEventListener('change', function(event) {
        handleNewMakeChange(event.target, newModelSelect, homepageSearchBoxSubmitButton, newOrUsedSelect);
    });
    handleNewMakeChange(newMake, newModelSelect, homepageSearchBoxSubmitButton, newOrUsedSelect);
    return function() {
        handleNewMakeChange(newMake, newModelSelect, homepageSearchBoxSubmitButton, newOrUsedSelect);
    };
}

const submitNewForm = function(form) {
    const newMake = form.querySelector('[name="new_make"]');
    if (newMake.value == '') {
        return;
    }
    const newModelSelect = form.querySelector('select[name="new_model"]');
    if (typeof newModelSelect.options[newModelSelect.selectedIndex].dataset.url !== 'undefined' && newModelSelect.options[newModelSelect.selectedIndex].dataset.url != '')  {
        document.location = newModelSelect.options[newModelSelect.selectedIndex].dataset.url;
        return;
    }
    document.location = newMake.value + '/new';
}

export { setupNewForm, submitNewForm };


// WEBPACK FOOTER //
// ./resources/assets/js/homepages/modules/multi-brand-search-new.js